import { Link } from "react-router-dom";
import { ArrowUpRight, Container, Droplets, Handshake, Truck } from "lucide-react";
import { Reveal } from "../../components/Motion";
import { WhatsAppIcon } from "../../components/Brand";
import { waLink } from "../../lib/site";

const Tile = ({ className = "", children, delay = 0, testid }) => (
  <Reveal delay={delay} className={className}>
    <div data-testid={testid} className="group relative h-full overflow-hidden rounded-[26px] transition-transform duration-500 hover:-translate-y-1">
      {children}
    </div>
  </Reveal>
);

export default function Bento() {
  return (
    <section data-testid="home-bento" className="bg-[var(--paper)] py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="eyebrow text-brand">What we do</p>
            <h2 className="mt-4 max-w-2xl font-display text-5xl md:text-6xl font-extrabold uppercase leading-[0.92] text-navy">
              One supplier for your fleet's fluids.
            </h2>
          </div>
          <p className="max-w-sm text-slate-600">From a single can for a workshop to regular bulk supply for transport businesses — we keep your vehicles moving.</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-12 md:auto-rows-[240px]">
          <Tile testid="bento-supply" className="md:col-span-7 md:row-span-2 min-h-[380px]">
            <img src="/img/real/shop-1.jpg" alt="MHM SUPER ADBLUE Tata D.E.F shop" className="absolute inset-0 h-full w-full object-cover object-[50%_45%] transition-transform duration-[1200ms] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-transparent" />
            <div className="absolute bottom-0 p-8 md:p-10 text-white">
              <Droplets className="h-8 w-8 text-brand" />
              <h3 className="mt-4 font-display text-4xl md:text-5xl font-extrabold uppercase leading-none">Our Tata D.E.F<br />shop network</h3>
              <p className="mt-3 max-w-md text-slate-200">AdBlue dispensing, buckets and IBC tanks for BS-VI trucks, buses and commercial vehicles.</p>
            </div>
          </Tile>
          <Tile testid="bento-bulk" delay={0.08} className="md:col-span-5">
            <Link to="/bulk-orders" className="flex h-full flex-col justify-between bg-brand p-8 text-white">
              <div className="flex items-start justify-between">
                <Container className="h-8 w-8" />
                <ArrowUpRight className="h-7 w-7 transition-transform duration-500 group-hover:rotate-45" />
              </div>
              <div>
                <h3 className="font-display text-4xl font-extrabold uppercase leading-none">Bulk orders</h3>
                <p className="mt-2 text-white/90">Drums, IBC totes and regular fleet supply on request.</p>
              </div>
            </Link>
          </Tile>
          <Tile testid="bento-lubricants" delay={0.12} className="md:col-span-5">
            <Link to="/products" className="flex h-full items-stretch bg-white border border-navy/10">
              <div className="flex flex-1 flex-col justify-between p-8">
                <p className="eyebrow text-slate-500">AdBlue brands</p>
                <div>
                  <h3 className="font-display text-3xl font-extrabold uppercase leading-none text-navy">Tata · Gulf<br />Eicher · BharatBenz</h3>
                  <p className="mt-2 text-sm text-slate-600">AdBlue buckets, IBC tanks and lubricating oils.</p>
                </div>
              </div>
              <div className="w-[38%] spotlight">
                <img src="/img/real/gulf-bucket.jpg" alt="Gulf AdBlue bucket" className="h-full w-full object-contain p-3 mix-blend-multiply transition-transform duration-700 group-hover:scale-110" />
              </div>
            </Link>
          </Tile>
          <Tile testid="bento-dealer" delay={0.08} className="md:col-span-4">
            <Link to="/dealer-franchise" className="flex h-full flex-col justify-between bg-navy p-8 text-white">
              <Handshake className="h-8 w-8 text-brand" />
              <div>
                <h3 className="font-display text-3xl font-extrabold uppercase leading-none">Dealer & franchise</h3>
                <p className="mt-2 text-slate-300">Partner with a growing AdBlue brand in your district.</p>
              </div>
            </Link>
          </Tile>
          <Tile testid="bento-whatsapp" delay={0.14} className="md:col-span-4">
            <a href={waLink()} target="_blank" rel="noreferrer" className="flex h-full flex-col justify-between bg-white border border-navy/10 p-8">
              <span className="grid h-12 w-12 place-items-center rounded-full bg-[#25D366] text-white"><WhatsAppIcon className="h-6 w-6" /></span>
              <div>
                <h3 className="font-display text-3xl font-extrabold uppercase leading-none text-navy">Quick WhatsApp quote</h3>
                <p className="mt-2 text-sm text-slate-600">Message us your requirement and get a fast reply.</p>
              </div>
            </a>
          </Tile>
          <Tile testid="bento-vision" delay={0.2} className="md:col-span-4">
            <div className="relative flex h-full flex-col justify-between bg-navy-light p-8 text-white">
              <Truck className="h-8 w-8 text-brand" />
              <div>
                <h3 className="font-display text-3xl font-extrabold uppercase leading-none">Built to scale<br />across India</h3>
                <p className="mt-2 text-slate-200">Our goal: a trusted AdBlue distribution brand nationwide.</p>
              </div>
            </div>
          </Tile>
        </div>
      </div>
    </section>
  );
}
